import { api, ApiCallOptions } from '~/api.ts';
import { GetAvailabilityResponse, Notification as NotificationType } from '~/types/platform.ts';

export async function getNotifications(apiCallOpts: ApiCallOptions) {
    return api<NotificationType[]>('/notifications', apiCallOpts);
}

export async function readNotifications() {
    return api<boolean>('/notifications/read', { method: 'POST' });
}

export async function getAvailability(id: number) {
    return api<GetAvailabilityResponse>(`/candidates/${id}/availability`);
}
